var _ = require('underscore/underscore');
var BasePopup = require('front/components/BasePopup/BasePopup');

var template = require('./EventsPopup.jinja');
require('./EventsPopup.less');

var CommonMap = require('front/components/CommonMap/CommonMap');
var CommonEventsList = require('front/components/CommonEventsList/CommonEventsList');
var CommonStory = require('front/components/CommonStory/CommonStory');

module.exports = BasePopup.extend({

    template: template,

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'CommonEventsList': {selector: '.CommonEventsList', viewConstructor: CommonEventsList},
        'CommonMap': {selector: '.CommonMap', viewConstructor: CommonMap},
        'CommonStory': {selector: '.CommonStory', viewConstructor: CommonStory}
    },

    events: _.extend({

    }, BasePopup.prototype.baseEvents),


    apiUrl: function () {
        var id = parseInt(this.slug.split('-')[0], 10);

        return Urls['front:api:events-popup'](id, 'json');
    },


    renderData: function () {
        return {
            popup: this.data || {}
        };
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'onResize');

        this.slug = this.options.slug;

        BasePopup.prototype.initialize.call(this, options);

        this.onResize();

        $(window).on('resize', this.onResize);
    },

    viewsRegistration: function () {
        BasePopup.prototype.viewsRegistration.call(this);
        var $map = this.$('.CommonMap');

        if ($map.size()) {
            var mapData = JSON.parse($map.attr('data-map'));
            var gmapsUrl = 'https://www.google.com/maps/place/' + encodeURIComponent(mapData.location.address)
                + '/@' + mapData.location.latlng.lat + ',' + mapData.location.latlng.lng + ',15z';
            this.$('.EventsPopup-infoBarItem--Place').attr('href', gmapsUrl);
        }
    },

    deactivate: function (params) {
        $(window).off('resize', this.onResize);

        return BasePopup.prototype.deactivate.call(this, params);
    },


    onResize: function () {
        var max = 0;

        this.$('.EventsPopup-infoBarItem').css('height', 'auto');

        this.$('.EventsPopup-infoBarItem').each(function () {
            max = Math.max(max, $(this).outerHeight());
        });

        this.$('.EventsPopup-infoBarItem').css('height', max);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/EventsPopup/EventsPopup.js
// module id = 261
// module chunks = 0